export default function NFTAmount({ amount, label }) {
  return (
    <div className='flex flex-col text-center'>
      <span className="font-black text-nftnumber">{amount}</span>
      <span className="text-base font-semibold uppercase">{label}</span>
    </div>
  )
}
